import { useState } from 'react';
import {
    useTheme,
    useMediaQuery,
    Container,
    Box,
    IconButton,
} from '@mui/material';
import {
    LightModeRounded,
    DarkModeRounded,
    AccountCircle,
    MenuRounded,
} from '@mui/icons-material';
import { 
    useSelector, 
    useDispatch, 
} from 'react-redux';
import { 
    useNavigate, 
    useLocation, 
} from "react-router-dom";
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { withPather } from 'react-pather';
import HeaderMenu from './HeaderMenu';
import Drawer from './Drawer';
import { 
    BigRoundedButton, 
    SendNewLinkMessage, 
} from '../general';
import { useToken } from '../../hooks';
import { toggleTheme } from '../../slices/themeSlice';
import { unSetUser } from '../../slices/userSlice';
import { roleIcon } from '../../utils';
import { PROJECT_NAME } from '../../config';

const Header = ({ pather }) => {

    const dispatch = useDispatch();
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const user = useSelector(state => state.user.value);
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const [confirmationLoading, setConfirmationLoading] = useState(false);

    // Drawer
    const [openDrawer, setOpenDrawer] = useState(false);
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
        setOpenDrawer(open);
    };
    //

    const { removeToken } = useToken();

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = e => {
        if (anchorEl !== e.currentTarget) {
            setAnchorEl(e.currentTarget);
        } 
    }
    const handleClose = () => setAnchorEl(null);
    
    const logout = () => {
        axios.post(pather.back.Auth.logout)
        .then(() => {
            removeToken();
            dispatch(unSetUser());
        })
        .catch(({ response: { data } }) => {
            enqueueSnackbar(data.status, { variant: 'error' });
            console.log(data.status);
        })
        .finally(() => {
            handleClose();
        })
    }

    const sendConfirmationLink = () => {
        setConfirmationLoading(true);
        axios.post(pather.back.confirmationLink)
        .then(resp => {
            console.log(resp);
            const data = resp?.data;
            enqueueSnackbar(data?.status, { variant: 'success' });
        })
        .catch(resp => {
            const data = resp?.response?.data;
            enqueueSnackbar(data?.status, { variant: 'error' });
            console.log(data);
        })
        .finally(() => {
            setConfirmationLoading(false);
        })
    }

    const icon = roleIcon();

    return (
        <Container sx={{height: '100%'}}>
            {   
                user.isLogined && !user.isConfirmed &&
                <SendNewLinkMessage 
                    loading={confirmationLoading}
                    sendNewLink={sendConfirmationLink}
                    message='Confirm your account clicking on a link in email'
                />
            }
            <Box sx={{ pl: 2, display: 'flex', alignItems: 'center', borderBottom: '0.3px solid #AAB4BE'}}>
                <Box>
                    <Box 
                        className="noselect"
                        sx={{ 
                            fontFamily: 'Emblema One', 
                            color: theme.palette.text.main, 
                            fontSize: 22,
                            cursor: 'pointer'
                        }}
                        onClick={() => navigate(location.pathname === '/' ? pather.front.shorten : '/')}
                    >
                        <span className='h1-style'>{PROJECT_NAME}</span>
                    </Box>
                </Box>
                {   
                    matches ?
                    <>
                        { 
                            !openDrawer &&
                            <Box sx={{ml: 'auto', display: 'flex', alignItems: 'center', columnGap: 1}}>
                                <IconButton onClick={toggleDrawer(true)} sx={{pb: 0}}>
                                    <MenuRounded fontSize='large'/>
                                </IconButton>
                            </Box> 
                        }
                    </> :
                    <Box sx={{ml: 'auto', display: 'flex', alignItems: 'center', columnGap: 1}}>
                        <Box sx={{display: 'flex', gap: 2, alignItems: 'center'}}>
                            <Box>
                                {/* FIXME: Too long username breaks UI */}
                                {user?.isLogined && <h3>{user.username}</h3>}
                            </Box>
                            {
                                icon && 
                                <Box>
                                    { icon }
                                </Box>
                            }
                        </Box>
                        {/* TODO: check whether here there are not too many Box components */}
                        <Box>
                            {
                                !user?.isLogined && location.pathname !== pather.front.login &&
                                <BigRoundedButton 
                                    text='Log in' 
                                    to={pather.front.login}
                                />
                            }
                        </Box>
                        <Box>
                            <IconButton onClick={() => dispatch(toggleTheme())} sx={{cursor: 'pointer'}}>
                                { 
                                    theme.palette.mode === 'dark' ?
                                    <LightModeRounded fontSize='large' /> :
                                    <DarkModeRounded fontSize='large' />
                                }
                            </IconButton> 
                        </Box>
                        { 
                            user?.isLogined &&
                            <Box>
                                <IconButton
                                    size="large"
                                    aria-owns={anchorEl ? "menu-appbar" : undefined}
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenuClick}
                                    color="inherit"
                                >
                                    <AccountCircle fontSize='large' />
                                </IconButton>
                                <HeaderMenu 
                                    anchorEl={anchorEl}
                                    handleClose={handleClose}
                                    logout={logout}
                                />
                            </Box>
                        }
                    </Box>
                }
            </Box>
            <Drawer 
                open={openDrawer}
                toggleDrawer={toggleDrawer}
                user={user}
                logout={logout}
            />
        </Container>
    );
}

export default withPather()(Header);